import type { RouteRecordRaw } from "vue-router";

const purchasesRoutes: RouteRecordRaw[] = [
  {
    path: "/credit-activity/view",
    name: "view-credit-activity",
    component: () => import("@/views/Purchases/ViewCreditActivity.vue"),
    meta: {
      title: "View Credit Activity",
      requiresAuth: true,
      purchasesPermission: "creditActivity",
    },
  },
  {
    path: "/purchases/view",
    name: "view-purchases",
    component: () => import("@/views/Purchases/ViewPurchases.vue"),
    meta: {
      title: "View Purchases",
      requiresAuth: true,
      purchasesPermission: "viewPurchases",
    },
  },
  {
    path: "/transactions/view",
    name: "view-transactions",
    component: () => import("@/views/Purchases/ViewTransactions.vue"),
    meta: {
      title: "View Transactions",
      requiresAuth: true,
      purchasesPermission: "transactions",
    },
  },
  {
    path: "/statements/view",
    name: "view-statements",
    component: () => import("@/views/Purchases/ViewStatements.vue"),
    meta: {
      title: "View Statements",
      requiresAuth: true,
      purchasesPermission: "statements",
    },
  },
  {
    path: "/purchase-summary/view",
    name: "view-purchase-summary",
    component: () => import("@/views/Purchases/ViewPurchaseSummary.vue"),
    meta: {
      title: "View Purchase Summary",
      requiresAuth: true,
      purchasesPermission: "purchaseSummary",
    },
  },
];

export default purchasesRoutes;
